import { findKey, includes, upperCase } from "lodash";

import countries from "i18n-iso-countries";

const _ = {
  findKey,
  includes,
  upperCase
};

countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

const language =
  (window.navigator.languages && window.navigator.languages[0]) ||
  window.navigator.language ||
  window.navigator.userLanguage;
const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

countries.registerLocale(
  require(`i18n-iso-countries/langs/${languageWithoutRegionCode}.json`)
);

class CountryTranslatorClass {
  constructor() {
    // lookup country code
    // console.log('countries', countries)
    const frCountries = countries.getNames("fr");
    // console.log('countries', countries)

    this.state = {
      frCountries
    };

    // console.log('language', language)
  }

  // Get the name of a country by it's ISO 3166-1 Alpha-2
  getName = (label, language) => {
    if (!!language) {
      countries.registerLocale(
        require(`i18n-iso-countries/langs/${language.toLowerCase()}.json`)
      );
      const trans = countries.getName(label, language.toLowerCase());
      if (!!!trans) {
        console.warn(
          "CountryTranslatorClass doesnt find",
          label,
          language.toLowerCase()
        );
      }
      return trans;
    }
    return countries.getName(label, languageWithoutRegionCode);
  };

  findFRCountryCodeByName = value => {
    // clean up ETATS-UNIS
    const valueClean = value.replace("-", " ");
    return _.findKey(this.state.frCountries, function(o) {
      // console.log(_.upperCase(o), value)
      return _.includes(_.upperCase(o), valueClean);
    });
  };
}

let CountryTranslator = new CountryTranslatorClass();
export default CountryTranslator;
